'use strict';

module.exports = {
  DataError: require('./DataError'),
  NotSupportedError: require('./NotSupportedError')
};


//////////////////
// WEBPACK FOOTER
// ../solid-auth-oidc/~/jose/lib/errors/index.js
// module id = 119
// module chunks = 0